// A content calendar in small, for its tile in All boards: this month's grid with each day's posts as short
// bars in their status colors, in the board's own tile colors.

import { monthGrid, monthName, monthOf, postOf } from "../../../shared/calendar";
import type { Board, Entry } from "../../../shared/types";
import { cx } from "../../lib/util";
import { today } from "./state";

export function CalendarThumb({ entries }: { board: Board; entries: Entry[] }) {
  const t = today();
  const month = monthOf(t);
  const days = monthGrid(month);
  const byDay = new Map<string, string[]>();
  for (const e of entries) {
    if (e.t !== "post") continue;
    const p = postOf(e);
    if (p.day) byDay.set(p.day, [...(byDay.get(p.day) ?? []), p.status]);
  }
  return (
    <div className="ov-cal">
      <b>{monthName(month)}</b>
      <div className="ov-ccal-grid" style={{ gridTemplateRows: `repeat(${days.length / 7}, 1fr)` }}>
        {days.map((d) => (
          <span key={d} className={cx(monthOf(d) !== month && "is-out", d === t && "is-today")}>
            {(byDay.get(d) ?? []).slice(0, 3).map((s, i) => (
              <i key={i} className={`st-${s}`} />
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
